import ActionsButton from 'components/tables/AGGrid/ActionsButton';

const WholesalerActionCellRenderer = ({ params, onEdit, walkthroughIds }) => (
    <ActionsButton
        actions={[
            {
                label: 'Edit Wholesaler',
                onClick: () => onEdit(params),
                dataAttributes: {
                    'data-walkthroughid': `${walkthroughIds?.ufEditButton}/${params.data.id}`,
                },
            },
        ]}
    />
);

export default WholesalerActionCellRenderer;
